import React from 'react';
import { TypedMemo } from '../../../common/types';
import styles from './SMLUpgradeBody.module.scss';
import { withBrandWord } from '../primitives/BrandWord';

interface SMLUpgradeBodyProps {
  /** The H2 — it names what the person reached for. */
  title: string;
  lede?: string;
  /** Sits above the title, centred. The success mark uses it. */
  lead?: React.ReactNode;
  /** Sits beside the title. The compare view puts its plan pill here. */
  titleRight?: React.ReactNode;
  children: React.ReactNode;
}

/** The body all three views share, so the H2 and lede read the same wherever you land. */
const SMLUpgradeBodyComponent: React.FC<SMLUpgradeBodyProps> = ({ title, lede, lead, titleRight, children }) => (
  <div className={styles.body}>
    {lead !== undefined && <div className={styles.lead}>{lead}</div>}
    <div className={styles.head}>
      <h2 className={styles.title}>{withBrandWord(title)}</h2>
      {titleRight}
    </div>
    {lede !== undefined && <p className={styles.lede}>{withBrandWord(lede)}</p>}
    {children}
  </div>
);

export const SMLUpgradeBody = TypedMemo(SMLUpgradeBodyComponent);
